import { Injectable } from '@angular/core';
import { ConfigMW } from '../interfaces/config.interface';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  getConfig(): ConfigMW {
    return window['config'] as ConfigMW;
  }
}
